export default __webpack_public_path__ + "static/media/Our-Services.5c18c309.png";